import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import EmailSettingComponent from '../components/emailSettingComponent';
import {getAllEmailSettings,updateApplicationRejection,updateApprovalTime,
    updateForgotPassword,updateRegistrationTime, updateSupport, updateAcknowledge} from '../action/emailSettingAction';

export class EmailSettingContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getAllEmailSettings();
    }
    allEmailSetting = () =>{
        this.props.actions.getAllEmailSettings(
            this.props.dispatch
        )
    }
    applicationRejection = (subject,body) =>{
        this.props.actions.updateApplicationRejection(
            subject,
            body,
            this.props.dispatch
        )
    }
    approvalTime = (subject,body) =>{
        this.props.actions.updateApprovalTime(
            subject,
            body,
            this.props.dispatch
        )
    }
    forgotPassword = (subject,body) =>{
        this.props.actions.updateForgotPassword(
            subject,
            body,
            this.props.dispatch
        )
    }
    registrationTime = (subject,body) =>{
        this.props.actions.updateRegistrationTime(
            subject,
            body,
            this.props.dispatch
        )
    }
    supportEmail = (subject,body) =>{
        this.props.actions.updateSupport(
            subject,
            body,
            this.props.dispatch
        )
    }
    acknowledgeEmail = (subject,body) =>{
        this.props.actions.updateAcknowledge(
            subject,
            body,
            this.props.dispatch
        )
    }
    render(){
        return(
            <EmailSettingComponent
                getAllEmailSettingData = {this.props.emailSettingData}
                updateRejection = {this.applicationRejection}
                updateApproval = {this.approvalTime}
                updateForgotPswd = {this.forgotPassword}
                updateRegistration = {this.registrationTime}
                updateSupportEmail = {this.supportEmail}
                updateAcknowledgeEmail = {this.acknowledgeEmail}
                allEmailSetting = {this.allEmailSetting}
            >    
            </EmailSettingComponent>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllEmailSettings,
            updateApplicationRejection,
            updateApprovalTime,
            updateForgotPassword,
            updateRegistrationTime,
            updateSupport,
            updateAcknowledge
        },
            dispatch)
    };
}
function mapStateToProps({ EmailSettingReducer }) {
    console.log(EmailSettingReducer);
    return {
        emailSettingData : {
            errorCode : EmailSettingReducer.errorCode,
            statusCode : EmailSettingReducer.statusCode,
            emailSettingList : EmailSettingReducer.emailSettingList,
            updatedEmailSetting : EmailSettingReducer.updatedEmailSetting
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmailSettingContainer));
